import Vue from 'vue'
import VueRouter from 'vue-router'
import { resetTitle } from '../utils/title'

Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    meta: { title: '热门资讯' },
    component: () => import( /* webpackChunkName: "Home" */ '../views/Home.vue')
  },
  {
    path: '/card',
    name: 'card',
    meta: { title: '个人名片' },
    component: () => import( /* webpackChunkName: "card" */ '../views/card.vue')
  },
  {
    path: '/details',
    name: 'details',
    meta: { title: '资讯详情' },
    component: () => import( /* webpackChunkName: "details" */ '../views/details.vue')
  },
  {
    path: '/trail',
    name: 'trail',
    meta: { title: '贸易合规自查表' },
    component: () => import( /* webpackChunkName: "trail" */ '../views/trail.vue')
  },
  {
    path: '/articleInfo',
    name: 'articleInfo',
    meta: { title: '资讯详情' },
    component: () => import( /* webpackChunkName: "details" */ '../views/articleInfo.vue')
  },
  {
    path: '/cardDetails',
    name: 'cardDetails',
    meta: { title: '名片详情' },
    component: () => import( /* webpackChunkName: "cardDetails" */ '../views/cardDetails.vue')
  },
  {
    path: '/bind',
    name: 'bind',
    meta: { title: '绑定手机号' },
    component: () => import( /* webpackChunkName: "cardDetails" */ '../views/bind.vue')
  },
  {
    path: '/flow',
    name: 'flow',
    meta: { title: '流量宝' },
    component: () => import( /* webpackChunkName: "cardDetails" */ '../views/flow.vue')
  },
  {
    path: '/opportunity',
    name: 'opportunity',
    meta: { title: '大宗商机' },
    component: () => import( /* webpackChunkName: "cardDetails" */ '../views/opportunity.vue')
  },
  {
    path: '/opportunity-info',
    name: 'opportunity-info',
    meta: { title: '商机详情' },
    component: () => import( /* webpackChunkName: "cardDetails" */ '../views/opportunity-info.vue')
  },
  {
    path: '/guoqi',
    name: 'guoqi',
    meta: { title: '国企' },
    component: () => import( /* webpackChunkName: "cardDetails" */ '../views/guoqi.vue')
  },
  {
    path: '/guoqiComp',
    name: 'guoqiComp',
    meta: { title: '合规自查表' },
    component: () => import( /* webpackChunkName: "guoqiComp" */ '../views/guoqiComp.vue')
  },
  {
    path: '/guoqiSoe',
    name: 'guoqiSoe',
    meta: { title: '假央企名单' },
    component: () => import( /* webpackChunkName: "guoqiSoe" */ '../views/guoqiSoe.vue')
  },
  {
    path: '/guoqiAi',
    name: 'guoqiAi',
    meta: { title: '我的审核记录' },
    component: () => import( /* webpackChunkName: "guoqiAi" */ '../views/guoqiAi.vue')
  },
  {
    path: '/guoqiRisk',
    name: 'guoqiRisk',
    meta: { title: '风控报告' },
    component: () => import( /* webpackChunkName: "guoqiRisk" */ '../views/guoqiRisk.vue')
  },
  {
    path: '/mine',
    name: 'mine',
    meta: { title: '我的' },
    component: () => import( /* webpackChunkName: "cardDetails" */ '../views/mine.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  routes
})

// 路由一切换就写入基础标题，同时作废上一个页面还没回来的异步标题
router.afterEach((to) => {
  resetTitle(to)
})

export default router
